import axios from 'axios'
import { API_URL } from '@/const'
import { store } from '@/store'
export const postAxiosMessage = (channel, msg) => {
  const { accessToken } = store.state.app.user
  const headers = {
    Authorization: `Bearer ${accessToken}`
  }
  axios
    .post(`${API_URL.MESSAGES}/${channel}`, msg, { headers })
    .then(() => {})
    .catch((err) => console.log(err.response.data))
}
